import { toAbsoluteUrl } from "../../_metronic/_helpers";

export function onErrorImg(e) {
  e.target.onerror = null;
  e.target.src = toAbsoluteUrl("/media/users/default.jpg");
}
